import { render } from "./Post.vue?vue&type=template&id=10e130b3"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"
script.render = render

export default script